export default __webpack_public_path__ + "static/media/minimize.c628a776.png";